import { makeStyles, Typography } from '@material-ui/core';
import React from 'react';

import { colors } from '../../themes/colors';

const useStyles = makeStyles({
  welcomeTextBody: {
    flex: 1,
    fontWeight: 100,
    marginBottom: 5,
  },
  availabilityHeaderText: {
    fontSize: 16,
    fontFamily: 'Avenir-Book',
    fontWeight: 900,
  },
  rosterText: {
    fontSize: 36,
    fontFamily: 'Avenir-Heavy',
    fontWeight: 900,
  },
  editLink: {
    color: colors.blue6,
    fontWeight: 900,
    cursor: 'pointer',
    textDecoration: 'underline',
    margin: 5,
    flex: 1,
  },
  welcomeContainer: {
    margin: 30,
    maxWidth: 1300,
    border: `1px solid ${colors.gray1}`,
    borderRadius: 5,
    backgroundColor: '#FFFFFF',
    minWidth: '90%',
    minHeight: 300,
    display: 'flex',
    flexDirection: 'row',
    height: 'fit-content',
    alignItems: 'center',
  },
  lampAndComputer: {
    flex: 0,
    width: 200,
    height: 75,
    justifySelf: 'center',
    margin: 30,
  },
  welcomeTextContainer: {
    flex: 1,
    flexDirection: 'column',
    margin: 30,
    minWidth: 200,
    maxWidth: '30%',
  },
  welcomeTextHeader: {
    flex: 0,
    fontSize: 18,
    fontFamily: 'Avenir-Book',
    fontWeight: 900,
  },
  myAvailability: {
    display: 'flex',
    height: '100%',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  setAvailabilityText: {
    margin: 0,
    textDecoration: 'underline',
  },
  leftContainer: {
    paddingLeft: 30,
    paddingRight: 30,
    borderLeft: `1px solid ${colors.gray1}`,
  },
  paragraphText: {
    marginTop: 6,
    marginBottom: 6,
    color: colors.gray8,
  },
});

enum AvailabilityWithRosterTestID {
  ManageAvailabilityLink = 'AvailabilityWithRosterTestID.ManageAvailabilityLink',
  Openings = 'AvailabilityWithRosterTestID.Openings',
}

interface Props {
  onManageAvailabilityClick: () => void;
  clientOpenings: number;
  firstName: string;
}

export const AvailabilityWithRoster: React.FC<Props> = ({
  firstName,
  clientOpenings,
  onManageAvailabilityClick,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.welcomeContainer}>
      <img
        className={classes.lampAndComputer}
        src={require('../../assets/images/lamp-and-computer.png')}
        alt="resource-item"
      />
      <div className={classes.welcomeTextContainer}>
        <Typography className={classes.welcomeTextHeader}>Welcome back, {firstName}</Typography>
        <div className={classes.welcomeTextBody}>
          <Typography className={classes.paragraphText}>
            Review and edit your availability to take on new clients, or connect a calendar to allow
            clients to book sessions with you directly.
          </Typography>

          <Typography
            className={`${classes.editLink} ${classes.setAvailabilityText}`}
            onClick={onManageAvailabilityClick}
            data-testid={AvailabilityWithRosterTestID.ManageAvailabilityLink}
          >
            Manage Availability
          </Typography>
        </div>
      </div>
      <div className={classes.myAvailability}>
        <div className={classes.leftContainer}>
          <Typography className={classes.availabilityHeaderText}>My Availability</Typography>
          <Typography
            className={classes.rosterText}
            data-testid={AvailabilityWithRosterTestID.Openings}
          >
            {clientOpenings}
          </Typography>
          <Typography className={classes.welcomeTextBody}>
            Client openings still available
          </Typography>
        </div>
      </div>
    </div>
  );
};
